import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly KEY = 'theme';

  readonly isDark = signal<boolean>(this.getInitialTheme());

  constructor() {
    effect(() => {
      const dark = this.isDark();
      document.documentElement.classList.toggle('dark', dark);
      localStorage.setItem(this.KEY, dark ? 'dark' : 'light');
    });
  }

  setDark(value: boolean) {
    this.isDark.set(value);
  }

  toggle() {
    this.isDark.update((v) => !v);
  }

  private getInitialTheme(): boolean {
    const saved = localStorage.getItem(this.KEY);

    if (saved) return saved === 'dark';

    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
}
